import { create } from 'zustand';

import {
  BlockRuleTypeOptions,
  TBlockRuleTypeOptions,
} from '@components/block-event-single/constant/constant';
import { getDefaultBlockEventData } from '@components/block-event-single/utils/initializeUtils';
import { IBlockEventData } from '@src/common/types/empTypes';

interface IBlockedDetailPanelStore {
  blockType: TBlockRuleTypeOptions;
  blockEventDataDraft?: IBlockEventData;
  blockEventData?: IBlockEventData;
  setBlockType: (blockType: TBlockRuleTypeOptions) => void;
  setBlockEventDataDraft: (blockEventDataDraft: IBlockEventData) => void;
  setBlockEventData: (blockEventData: IBlockEventData) => void;
  setBlockEventNote: (description?: string) => void;
  resetBlockedDetailPanelStore: () => void;
}

export const useBlockedDetailPanelStore = create<IBlockedDetailPanelStore>((set, get) => ({
  // Reasons for using blockType to control Block All/Block if instead of blockEventRules control:
  //   When switching from Block if to Block All, the blockEvent rules are not deleted,
  //   so that when switching from Block All to Block if, you can see the rules before the switch.
  blockType: BlockRuleTypeOptions[0].value,
  blockEventDataDraft: getDefaultBlockEventData(),
  blockEventData: getDefaultBlockEventData(),
  setBlockType: (blockType) => set(() => ({ blockType })),
  setBlockEventDataDraft: (blockEventDataDraft) => set(() => ({ blockEventDataDraft })),
  setBlockEventData: (blockEventData) => set(() => ({ blockEventData })),
  setBlockEventNote: (description) => {
    const setBlockEventDataDraft = get().setBlockEventDataDraft;
    let blockEvent = get().blockEventDataDraft;
    if (blockEvent) {
      blockEvent = {
        ...blockEvent,
        description,
      };
      setBlockEventDataDraft(blockEvent);
    }
  },
  resetBlockedDetailPanelStore: () =>
    set(() => ({
      blockType: BlockRuleTypeOptions[0].value,
      blockEventDataDraft: getDefaultBlockEventData(),
      blockEventData: getDefaultBlockEventData(),
    })),
}));
